export function loadScript(filePath) {
    return new Promise((resolve, reject) => {
        //First check to see if the script is already in the DOM.
        const existingScriptTag = document.querySelector(`script[src="${filePath}"]`);
        if (existingScriptTag != null) {
            //console.log('ls - Script tag already in the DOM, no need to load again');
            //Now that we know if it's an existing tag, we need to know if the script has already run.
            //If it has already downloaded an run, we need to resolve this promise right away.
            if (existingScriptTag.getAttribute('async') == null ||
                existingScriptTag.getAttribute('data-is-loaded') === 'true') {
                resolve(`Script already loaded (sync):  ${filePath}`);
                return;
            }
            //If it has not already downloaded and run, we need to monkey patch the onload and onerror callbacks of the existing script tag so this promise will be notified of things finishing as well.
            const existingOnload = existingScriptTag.onload;
            const existingOnerror = existingScriptTag.onerror;
            //Monkey-patching the onload function of the previous script.
            existingScriptTag.onload = function (...args) {
                if (existingOnload != null) {
                    existingOnload.apply(existingScriptTag, args);
                }
                resolve(`Script already loaded (async):  ${filePath}`);
            };
            existingScriptTag.onerror = function (...args) {
                if (existingOnerror != null) {
                    existingOnerror.apply(existingScriptTag, args);
                }
                reject(`Error loading script ${filePath}`);
            };
            return existingScriptTag;
        }
        else {
            //console.log('ls - loading ' + filePath);
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.onerror = function () {
                console.error(`Error loading script ${filePath}`);
                reject(`Error loading script ${filePath}`);
            };
            script.onload = function () {
                //console.log(`Success loading script ${filePath}`);
                resolve(`Success loading script ${filePath}`);
                //Mark that the script has loaded so subsequent calls to loadScript can detect if the onload function was already called.
                script.setAttribute('data-is-loaded', 'true');
            };
            script.src = filePath;
            document.head.appendChild(script);
        }
    });
}
